import MagnifierMouseMoveHandler from "./mousemove-handler";
import MagnifierMouseEnterHandler from "./mouseenter-handler";
import MagnifierMouseOutHandler from "./mouseout-handler";
import "./image-magnifier.scss";

class ImageMagnifier {
  constructor(wrapperClass, config) {
    if (!wrapperClass) throw new Error("ImageMagnifier: Unique wrapper ID is required");
    this.wrapperClass = `.${wrapperClass}`;
    this.config = config || {};
  }

  /**
   * @returns void
   * @description This method is called to initialize the magnifier and its event handlers.
   */
  initializeMagnifier() {
    MagnifierMouseEnterHandler({ eventSelector: this.wrapperClass, config: this.config });
    MagnifierMouseOutHandler({ eventSelector: this.wrapperClass });
    MagnifierMouseMoveHandler({ eventSelector: this.wrapperClass });
  }
}

export default ImageMagnifier;
